import { Client } from '@microsoft/microsoft-graph-client';
import { NovaOportunidadeForm } from '../components/NovaOportunidadeModal';

const APP_URL = 'https://pipeline-dcm-dti.pages.dev';
const TEAM_ID = '050ad99b-0592-40db-92a9-6cd66b0643ea';
const CHANNEL_ID = '19:orHgY8vQNTKmYz9VR3MrdtNM19GAfFb3in6VI43Kjf41@thread.tacv2';

// Cria a mensagem inicial da oportunidade e devolve o messageId para guardar no SharePoint
export async function notifyNewOpportunity(
  client: Client,
  form: NovaOportunidadeForm
): Promise<{ ok: boolean; log: string[]; messageId?: string }> {
  const logs: string[] = [];
  try {
    const slaLine = form.dataLimiteParecer
      ? `<tr><td><b>⏱ Data Limite:</b></td><td>${form.dataLimiteParecer}</td></tr>` : '';

    const content = `<p>🆕 <b>Nova Oportunidade — ${form.titulo}</b></p>
<p>Comercial: <b>${form.comercialNome}</b> &nbsp;|&nbsp; Técnico DTI: <b>${form.tecnicoNome || '—'}</b></p>
<table>
<tr><td><b>🏢 Cliente:</b></td><td>${form.cliente}</td></tr>
${slaLine}
<tr><td><b>📝 Âmbito:</b></td><td>${form.ambitoNecessidades}</td></tr>
</table>
<p>🔗 ${APP_URL}</p>`;

    const response = await client
      .api(`/teams/${TEAM_ID}/channels/${CHANNEL_ID}/messages`)
      .post({ body: { contentType: 'html', content } });

    const messageId: string = response?.id;
    logs.push('✓ Mensagem enviada — id: ' + messageId);
    return { ok: true, log: logs, messageId };
  } catch (e: any) {
    logs.push('✗ ' + (e?.message || JSON.stringify(e)));
    console.error('[TeamsNotify]', logs.join('\n'));
    return { ok: false, log: logs };
  }
}

// Envia mensagem nova (para oportunidades sem thread ainda) e devolve messageId
export async function notifyPhaseUpdate(
  client: Client,
  titulo: string,
  novaFase: string,
  autor: string,
  detalhe?: string
): Promise<{ ok: boolean; log: string[]; messageId?: string }> {
  const logs: string[] = [];
  try {
    const faseEmoji: Record<string, string> = {
      '1. Levantamento Inicial':        '📋',
      '2. Levantamento de Necessidades':'🔍',
      '3. Especificação Técnica':       '⚙️',
      '4. Proposta em Elaboração':      '✏️',
      '5. Proposta Enviada':            '📤',
      '6. Decisão do Cliente':          '🤝',
      '7. Ordem de Trabalho Gerada':    '📄',
      '8. Em Execução':                 '🔧',
      '9. Entrega & Validação':         '✅',
      '10. Concluído / Ganho':          '🏆',
      '11. Perdido / Cancelado':        '❌',
    };
    const emoji = faseEmoji[novaFase] || '➡️';
    const now = new Date();
    const hora = now.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
    const data = now.toLocaleDateString('pt-PT');
    const detalheHtml = detalhe ? `<p><i>${detalhe}</i></p>` : '';

    const content = `<p>${emoji} <b>Actualização — ${titulo}</b></p>
<p>Estado: <b>${novaFase}</b></p>
<p>Por: ${autor} &nbsp;|&nbsp; ${data} ${hora}</p>
${detalheHtml}
<p>🔗 ${APP_URL}</p>`;

    const response = await client
      .api(`/teams/${TEAM_ID}/channels/${CHANNEL_ID}/messages`)
      .post({ body: { contentType: 'html', content } });

    const messageId: string = response?.id;
    logs.push('✓ Mensagem de fase enviada — id: ' + messageId);
    return { ok: true, log: logs, messageId };
  } catch (e: any) {
    logs.push('✗ ' + (e?.message || JSON.stringify(e)));
    return { ok: false, log: logs };
  }
}

// Envia um reply no thread da oportunidade com a actualização de fase
export async function replyPhaseUpdate(
  client: Client,
  messageId: string,
  titulo: string,
  novaFase: string,
  autor: string,
  detalhe?: string
): Promise<{ ok: boolean; log: string[] }> {
  const logs: string[] = [];
  try {
    const now = new Date();
    const hora = now.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
    const data = now.toLocaleDateString('pt-PT');

    const faseEmoji: Record<string, string> = {
      '1. Levantamento Inicial':        '📋',
      '2. Levantamento de Necessidades':'🔍',
      '3. Especificação Técnica':       '⚙️',
      '4. Proposta em Elaboração':      '✏️',
      '5. Proposta Enviada':            '📤',
      '6. Decisão do Cliente':          '🤝',
      '7. Ordem de Trabalho Gerada':    '📄',
      '8. Em Execução':                 '🔧',
      '9. Entrega & Validação':         '✅',
      '10. Concluído / Ganho':          '🏆',
      '11. Perdido / Cancelado':        '❌',
    };
    const emoji = faseEmoji[novaFase] || '➡️';
    const detalheHtml = detalhe ? `<p><i>${detalhe}</i></p>` : '';

    const content = `<p>${emoji} <b>Actualização de Fase</b> — ${titulo}</p>
<p>Estado: <b>${novaFase}</b></p>
<p>Por: ${autor} &nbsp;|&nbsp; ${data} ${hora}</p>
${detalheHtml}
<p>🔗 ${APP_URL}</p>`;

    await client
      .api(`/teams/${TEAM_ID}/channels/${CHANNEL_ID}/messages/${messageId}/replies`)
      .post({ body: { contentType: 'html', content } });

    logs.push('✓ Reply enviado para thread ' + messageId);
    return { ok: true, log: logs };
  } catch (e: any) {
    logs.push('✗ ' + (e?.message || JSON.stringify(e)));
    console.error('[TeamsNotify:reply]', logs.join('\n'));
    return { ok: false, log: logs };
  }
}
